import { ApiEndpoints } from "@shared/api/api-endpoints";
import { cxApiClient, onboardingApiClient, consumerApiClient, activityLogApiClient } from "@shared/api/clients/apiClientFactory";

// Define the payload type locally
export interface AddHelpfullPayload {
  remote_utility_id?: string;
  source_id?: string;
  is_helpful?: any;
  remarks?: string;
  [key: string]: any;
}

import { getRemoteUtilityId } from "@shared/utils/loginUtils";
export const guestPortalApi = {
  // --- Tips API ---
  getTipsData: async (params: {
    remote_utility_id: string;
    utility_service: any;
    show_inactive: any;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/tips",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        if (params.utility_service) {
          qs.push("utility_service", params.utility_service);
        }
        qs.push("show_inactive", params.show_inactive);
      }
    );
    const response = await onboardingApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } }); 
    return response.data;
  },
  
  addHelpfulTips: async (payload: AddHelpfullPayload): Promise<any> => {
    const updatedPayload = { ...payload, remote_utility_id: payload.remote_utility_id || getRemoteUtilityId() };
    const url = ApiEndpoints.createUrl("consumerWeb", "consumer-tips-status");
    const response = await cxApiClient.post(url, updatedPayload, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  // --- Offices API ---
  getServiceDetail: async (params: {
    remote_utility_id: string;
    consumer_id: string;
    search_data?: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "service-center",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("consumer_id", params.consumer_id || "");
        if (params.search_data) {
          qs.push("search_data", params.search_data);
        }
      }
    );
    const response = await cxApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } }); 
    return response.data;
  },

  // --- FAQs API ---
  getFaq: async (params: {
    remote_utility_id: string;
    show_inactive: any;
    faq_category: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/faq",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("show_inactive", params.show_inactive);
        qs.push("faq_category", params.faq_category);
      }
    );
    const response = await onboardingApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  searchFaq: async (params: {
    search_data: string;
    remote_utility_id: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "search/onboarding_config",
      (qs) => {
        qs.push("search_field", "faq");
        qs.push("search_data", params.search_data);
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
      }
    );
    const response = await onboardingApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  addHelpfulFaq: async (payload: AddHelpfullPayload): Promise<any> => {
    const updatedPayload = { ...payload, remote_utility_id: payload.remote_utility_id || getRemoteUtilityId() };
    const url = ApiEndpoints.createUrl("onboarding", "config-map/faq");
    const response = await onboardingApiClient.patch(url, updatedPayload, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  // --- Billing API ---
  getPendingBills: async (params: {
    remote_utility_id: string;
    consumer_number: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "pending-consumer-bills",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("consumer_number", params.consumer_number);
      }
    );
    const response = await cxApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  // --- Service Request API ---
  getUtilityRequestConfiguration: async (params: {
    remote_utility_id: string;
    request_type: string;
    disable_pagination: boolean;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "utility-request-configuration",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("request_type", params.request_type);
        qs.push("disable_pagination", params.disable_pagination ? "true" : "false");
      }
    );
    const response = await cxApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  // --- Consumer Onboarding API ---
  getCategory: async (params: { remote_utility_id?: string }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/category_json",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("config_level", "category");
      }
    );
    const response = await consumerApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  getSubCategory: async (params: { remote_utility_id?: string, code_list: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/category_json",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("config_level", "sub_category");
        qs.push("code_list", params.code_list);
      }
    );
    const response = await consumerApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  getCity: async (params: { remote_utility_id?: string }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/territory_json",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("config_level", "county");
        qs.push("show_inactive", "true");
      }
    );
    const response = await consumerApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  getOwnerType: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "choices/ownership");
    const response = await consumerApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  getUtilityServices: async (params: { remote_utility_id?: string }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "utility/services",
      (qs) => {
        qs.push("utility_id", params.remote_utility_id || getRemoteUtilityId());
      }
    );
    const response = await consumerApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data?.result ?? [];
  },

  getConsumerRelation: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "choices/consumer_relation");
    const response = await consumerApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  addConsumer: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "consumer");
    const response = await consumerApiClient.post(url, payload, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  updateConsumer: async (consumerId: string, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", `consumer/${consumerId}`);
    const response = await consumerApiClient.put(url, payload, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  getConsumerDetail: async (params: { consumer_id: any, remote_utility_id?: string }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "consumer-detail",
      (qs) => {
        qs.push("consumer_id", params.consumer_id);
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
      }
    );
    const response = await consumerApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  getApplicationStatus: async (params: { consumer_no: string, remote_utility_id?: string }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "activityLog",
      "logs",
      (qs) => {
        qs.push("consumer_no", params.consumer_no);
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("self_service", "true");
      }
    );
    const response = await activityLogApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  getGuestPortalBranding: async (params: {
    remote_utility_id: string
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "guest-portal-branding",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  },

  // --- Master Account Search API ---
  searchMasterConsumers: async (params: {
    remote_utility_id: string;
    search_data: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "consumer-search/info",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id || getRemoteUtilityId());
        qs.push("search_data", params.search_data);
        qs.push("is_master_consumer", "1");
      }
    );
    const response = await cxApiClient.get(url, { headers: { Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-' } });
    return response.data;
  }
};
